import {
  AfterViewInit,
  Directive,
  ElementRef,
  Inject,
  OnDestroy,
  PLATFORM_ID,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { StickyZipCtaService } from '../../core/services/sticky-zip-cta.service';

@Directive({
  selector: '[appStickyZipAnchor]',
  standalone: true,
})
export class StickyZipAnchorDirective implements AfterViewInit, OnDestroy {
  constructor(
    private elementRef: ElementRef<HTMLElement>,
    private stickyZipCtaService: StickyZipCtaService,
    @Inject(PLATFORM_ID) private platformId: object
  ) {}

  ngAfterViewInit(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    this.stickyZipCtaService.registerAnchor(this.elementRef.nativeElement);
  }

  ngOnDestroy(): void {
    this.stickyZipCtaService.unregisterAnchor(this.elementRef.nativeElement);
  }
}
